import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from '../../../common/elements'
import { PromoModalOffer, PromoModalTitle } from './elements'
import { NetworkHelpers as Network, PromotionHelpers as Promotions } from '../../../../helpers';
import * as basketActions from '../../../../actions/transactions/basket';
import * as profileActions from '../profile/actions';

class PromoModalPage extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            closeModal: false,
        };
    };

    componentWillMount() {
        const { profile, getProfile, network } = this.props,
            networkId = Network.getCurrentNetwork( network ),
             personId = localStorage.getItem( "person_id" );

        if( !profile ) {
            getProfile( personId, networkId )
        } else return null;
    };

    closePromoModal = () => {
        this.setState({
            closeModal: true,
        });
    };

    render () {

        const { network, promotionAddedToBasket, profile, promotion, addPackageToBasket, addProductToBasket, history, promotionalPackages, promotionalProducts } = this.props,
              { closeModal } = this.state,
                      isOpen = true,
                        promoType = promotionalPackages.length > 0 ? "package" : "product",
                            productId = promotionalPackages[0] ? promotionalPackages[0].package_id : promotionalProducts[0].product_id,
                            currentPromo = Promotions.getActivePromotionDetails( productId, promoType );

        if ( !isOpen ) return null;
        if ( !profile ) return <Loader network={ network } />;

        if( closeModal ) return <div />;

        if( parseInt( localStorage.promo_added, 10 ) !== 1 ) {
            if( currentPromo.type === 1 ) {
                return (
                    <div className="promospage-body offer-ITN">{/*for product offer - .offer-ITN must be changed to offer-NED*/}
	                    <div className="cover-promos">
		                    <button className="close" onClick={ this.closePromoModal }><i className="fa fa-times"/></button>
		                    <img className="logo-top-right" src="/images/In-Touch-Networks-logo-white.png" alt="Network Brand Logo"/>
		                    <div className="container">
			                    <div className="row">
				                    <div className="col-xs-12 col-md-10 col-md-offset-1">
					                    <PromoModalTitle name={ `${ profile.first_name } ${ profile.last_name }` } description={ currentPromo.content } />
					                    test
					                    <PromoModalOffer addPromotionProductToBasket={ id => addProductToBasket( id ) } promotion={ promotion } network={ network } history={ history } />
				                    </div>
			                    </div>
		                    </div>
	                    </div>

                    </div>
                );
            } else {
                return (
                    <div className="promospage-body offer-ITN">
	                    <div className="cover-promos">
		                    <img className="logo-top-right" src="/images/In-Touch-Networks-logo-white.png" alt="In Touch Networks Logo"/>
		                    <button className="close" onClick={ this.closePromoModal }><i className="fa fa-times" /></button>
		                    <div className="container">
			                    <div className="row">
				                    <div className="col-xs-12 col-md-10 col-md-offset-1">
					                    <PromoModalTitle name={ `${ profile.first_name } ${ profile.last_name }` } description={ currentPromo.content } />
					                    <PromoModalOffer profile={ profile } addPromotionPackageToBasket={ id => addPackageToBasket( id ) } promotion={ promotion } network={ network } history={ history } />
				                     </div>
			                    </div>

		                    </div>
	                    </div>

                    </div>
                );
            }
        } else return <div></div>;
    };
}

const mapStateToProps = ( state ) => {
    return {
        profile: state.profile.profile,
        promotionAddedToBasket: state.transactions.promotionAddedToBasket,
        promotionalPackages: state.transactions.promotional_packages,
        promotionalProducts: state.transactions.promotional_products,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getProfile: ( personId, networkId ) => dispatch( profileActions.getProfile( personId, networkId) ),
        addProductToBasket: productId => dispatch( basketActions.addProductToBasket( productId ) ),
        addPackageToBasket: packageId => dispatch( basketActions.addPackageToBasket( packageId ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( PromoModalPage );



// WEBPACK FOOTER //
// src/client/components/site/features/promos/PromoModalPage.js